import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.css'],
    standalone: false
})
export class AlertDialogComponent implements OnInit {
    public title: string;
    public message: string;
    public className: string;
    public showAcceptButton: boolean = true;
    public acceptButtonText: string = 'Aceptar';

    constructor(
        public dialog: MatDialogRef<AlertDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = data?.title;
        this.message = data?.message;
        this.className = data?.className;
        this.showAcceptButton = data?.showAcceptButton !== false;
        this.acceptButtonText = data?.acceptButtonText || 'Aceptar';
    }

    ngOnInit(): void {
    }

    close(): void {
        this.dialog.close(false);
    }
}
